define('vspot-angular/services/user-service',['vspot-user'], function (ServerUser) {
    'use strict';

    return ['resources.User', 'services.Cookie', function (User, Cookie) {
        var user = {
            loggedIn: false,
            usingFacebook: false
        };
        // var fb;
        var refreshWaiting;
        var loginSource;

        if (window.location.href.indexOf('client') > 1) {
            //participant page
            loginSource =  'participant_path'
        } else {
            //organizer page
            loginSource = 'organizer_path'
        }

        // make facebook optional, in case the service is blocked or down
        require(['facebook'],
            function() {
                // fb = FB;
                // Keeps track of user's logged in status when logged in with facebook
                if (FB) {
                    FB.Event.subscribe('auth.authResponseChange', function (response) {
                        // The response object is returned with a status field that lets the
                        // app know the current login status of the person.
                        // Full docs on the response object can be found in the documentation
                        // for FB.getLoginStatus().
                        if (response.status === 'connected') {
                            // Logged into your app and Facebook.
                            user.usingFacebook = true;
                            FB.api('/me');
                        } else if (response.status === 'not_authorized') {
                            // The person is logged into Facebook, but not your app.
                            user.usingFacebook = true;
                            FB.api('/me');
                        } else {
                            // The person is not logged into Facebook, so we're not sure if
                            // they are logged into this app or not.
                            if (!loggedIn) {
                                // redirect to login page
                                user.usingFacebook = false;
                                window.location = '/login/signin?triggerUri=' + encodeURIComponent(window.location.href) + '&fn=facebook';
                            }
                        }
                    });
                }
            },
            function(error) {
                // load failed
            }
        );

        return {
            /*
             *  Authenticates user and initializes a session.
             *
             *  @param  email      String
             *  @param  password   String
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean, code: string, email: string, user: object }
             */
            login: function (email, password) {
                var resource = User.login({ email: email, password: password });

                resource.$promise.then(function (result) {
                    if (result.status) {
                        user                    = result.user;
                        // Some fix-ups to match the vspot-user.js file format
                        user.loggedIn           = true;
                        user.firstName          = result.user.first_name;
                        user.lastName           = result.user.last_name;
                        user.zipCode            = result.user.zipcode;
                        user.premiumData        = result.user.premium_data;
                        user.phoneNumber        = result.user.phonenumber;
                        user.premiumEndDate     = result.user.premiumenddate;
                        user.premiumStartDate   = result.user.premiumstartdate;
                    }
                }, function (err) {
                    // log error
                });

                return resource;
            },

            /*
             *  Logs in the user with facebook
             *
             *  @param callback {function} Call to make once logged in.
             *  @param callOnError {bool} Should the callback be called regardless?
             *
             * The callback function is only called on success. Apparently on error
             * it is just ignored...? Not sure about the value of that. Now we can
             * override that behavior and ask the callback to call anyway.
             * TODO: This seems like stupid behavior. Change the callbacks to always be called
             * but accept error data in case something didn't work - and let the user know!
             *
             * Calls the callback function with email, mobile_redirect?, and the
             * entire result as that could be useful info to the callback function.
             * TODO: change callback to just send the result instead of
             * sending duplicate data, as email and mobile_redirect? are in the result.
             */
            fbLogin: function (callback, callOnError) {
                var self = this;

                if( callOnError === undefined ) {
                    // Assume not... we don't want to change the default behavior without understanding it.
                    callOnError = false;
                }

                if (!FB || typeof(FB) === 'undefined' || typeof(FB) !== 'object' || typeof(FB.login) !== 'function') {
                    return false;
                } else {
                    // we get intermittent facebook login failures with "init not called with valid version" so retry after initiing if needed
                    // this seems to be an interaction with the ad blockers but just not clear
                    for (var retries = 0;; retries++) {
                        try {
                            FB.login(function (auth) {
                                // do not redirect if the user pressed cancel
                                if (auth.authResponse && auth.status !== 'unknown') {
                                    user.usingFacebook = true;
                                    // get user data to connect with our data
                                    FB.api('/me?fields=email,name', function (userResponse) {
                                        self.verifyFbLogin(auth.authResponse, userResponse, loginSource).$promise.then(function (result) {
                                            if (result.status || callOnError) {
                                                callback(result.email, result.mobile_redirect, result);
                                            }
                                        });
                                    });
                                } else if (callOnError) {
                                    callback(undefined, undefined, {status: false, auth: auth});
                                }
                            }, {scope: 'public_profile,email'}); // defines what we want access to
                            break ;
                        } catch (e) {
                            // call init and retry ONCE
                            if (retries < 1) {
                                console && console.log("FB.login failed, trying reinitializing " + e.toString());
                                FB.init({
                                    appId: '1731142263830615', // app id from signup '385770938175078', // App ID from the App Dashboard
                                    version: 'v19.0', // 'v3.3', // 'v2.6', // Determines which versions of the Graph API to use - see version list here https://developers.facebook.com/docs/apps/changelog/
                                    cookie: true, // set sessions cookies to allow your server to access the session?
                                    channelUrl: document.URL + 'fb/channel.html', // Channel File for x-domain communication
                                    status: true, // check the login status upon init?
                                    xfbml: true  // parse XFBML tags on this page?
                                });
                                continue;
                            } else {
                                throw e;
                            }
                        }
                    }

                    return true;
                }
            },
            verifyFbLogin: function (authResponse, userResponse, loginSource) {
                return User.verifyFbLogin({ authResponse: authResponse, userResponse: userResponse, source: loginSource });
            },
            /*
             *  Checks to see if the user is logged in.
             *  Redirects to login page if not.
             *
             *  @returns  True if the user is logged in.
             */
            isLoggedIn: function() {
                var user = this.get(true);

                if (user) {
                    return user.loggedIn;
                } else {
                    return false;
                }
            },
            /*
             *  Gets the user object if the user is logged in.
             *  Redirects to login page if not.
             *
             *  @param  preventRedirect  If true, prevents the default behavior of redirecting
             *                           to the login page if the user is not logged in.
             *
             *  @returns  The user object.
             */
            get: function(preventRedirect) {
                if (user.loggedIn) {
                    // client side user is logged in
                    return user;
                } else if (ServerUser.loggedIn) {
                    // A page load has occurred since the user logged in,
                    // and AngularJS does not remember. Get the user object
                    // populated by the server.

                    user = ServerUser;

                    return user;
                } else if (!preventRedirect) {
                    // not logged in
                    // assume user is trying to access unauthorized area
                    // and redirect them to login
                    window.location = '/login/signin?triggerUri=' + encodeURIComponent(window.location.href) + '&fn=get';
                    throw new Error('0');   // stop execution because other things depend on user object. 0 will not create a puppy
                    return false;
                } else {
                    return false;
                }
            },

            /*
             * refresh - re-get the user data from the server... if you are already
             * logged in. This is just for updating the data for an already logged
             * in user. It will not take users from a logged out state to a logged
             * in state.
             */
            refresh: function() {
                if(ServerUser.loggedIn) {

                    // don't hammer the server if we're waiting for a response
                    if(!refreshWaiting) {
                        refreshWaiting = true;
                        
                        var resource = User.get({ id: ServerUser.id });
                        resource.$promise.then(function (result) {
                            if(result.status && result.user) {
                                // copy new values into our existing user
                                ServerUser.email = result.user.email;
                                ServerUser.premium = result.user.premium;
                                ServerUser.premiumEndDate = result.user.premiumEndDate;
                                ServerUser.premiumStartDate = result.user.premiumStartDate;
                            }
                            refreshWaiting = false;
                        });
                        user = ServerUser;
                        return user;
                    }
                }
            },

            /*
             * get what the server thinks is the current user. Different from the other get and refresh in that
             * they only work with *logged in* users and this also works with volunteers.
             */
            getCurrent: function() {
                return User.get({ id: 'current' });
            },

            /*
             *  Registers the user and logs them in.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean, code: string, email: string, user: object }
             */
            register: function (postData) {
                var resource = User.save({}, postData);

                resource.$promise.then(function (result) {
                    if (result.status) {
                        user            = result.user;
                        user.loggedIn   = true;
                    }
                }, function (err) {
                    // log error
                });

                return resource;
            },
            /*
             *  Updates user data. Make sure to include id in postData.
             *
             *  @param  postData  An object containing all the data to be updated
             *
             *  @returns  Resource object. See /resources.js documentation for details
             */
            update: function (postData) {
                return User.update(postData);
            },
            /*
             *  Sends an email with a summary of all the activities that the user
             *  has signed up for.
             *
             *  @param  email  The email to send the invitation summary to
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string, num_invitations: int }
             *            num_invitations: Number of invitations that the user has
             */
            sendInvitations: function (email) {
                return User.sendInvitations({ email: email });
            },
            /*
             *  Checks to see if a given email is valid and available.
             *
             *  @param  email  The email to verify
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string }
             */
            checkEmailAvailability: function (email) {
                return User.verifyEmail({ email: email, strict: true });
            },

            /*
             *  Checks the validity of an email. The default behavior is to check to
             *  see if it's alright for a user to switch to the given email (that is
             *  setting "strict" to false). You can also generally check to see if
             *  an email is available to register a new account with (setting "strict"
             *  to true). In both cases, the server validates that the email is valid.
             *  However, some errors can be ignored by the client.
             *
             *  @param  email  {str} The email to verify
             *  @param  strict {bool} Should we enable strict checking - assume not
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string }
             */
            verifyEmail: function (email, strict) {
                if( strict === undefined ) {
                    strict = false;
                }
                return User.verifyEmail({ email: email, strict: strict });
            },

            /*
             * Given an email address, verify the user is registered with SignUp.com.
             */
            verifyRegistered: function(email) {
                return User.verifyRegistered({ email: email });
            },

            /*
             *  Gets additional user information not attained on login.
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             */
            getProfile: function () {
                return User.getProfile();
            },
            /*
             *  Resets a user's password and sends them an expiring link that allows them
             *  to login and update the password themselves.
             *
             *  @param  email  The email to use to look up the account
             *
             *  @returns  Resource object. See /resources.js documentation for details.
             *            Expected return data: { status: boolean, code: string }
             */
            resetPassword: function (email) {
                return User.resetPassword({ email: email });
            },
            getOrganizerTypes: function () {
                return User.getOrganizerTypes();
            },
            updateProfile: function (postData) {
                return User.updateProfile(postData);
            },
            getUserAssociatedSchools: function () {
                return User.getUserAssociatedSchools();
            },

            /*
             * getCookie:
             *      Retrieve the cookie for the user if it is set. Otherwise, we
             *      return the default value.
             *
             *  @param {string} key - the name of the cookie to create/update
             *  @param {any}    defaultValue - any type of object to return as default
             *
             *  @return {any}   The return value if we retrieved that, or the defaultValue if not.
             */
            getCookie: function(key, defaultValue) {
                // Cover the failure case first
                var returnValue = defaultValue;

                // Now check for a match
                if( user.cookies && user.cookies[key] !== undefined ) {
                    if (user.cookies[key].value) {
                        returnValue = JSON.parse(user.cookies[key].value);
                    } else {
                        // value is blank
                        returnValue = '';
                    }
                }

                return returnValue;
            },

            /*
             * setCookie:
             *      Set the cookie for the user, and update the value of the current
             *      cookie the user has stored... because we get the same cached
             *      object back each time.
             *
             *  @param {string} key - the name of the cookie to create/update
             *  @param {any}    value - any type of object to store in a cookie.
             */
            setCookie: function(key, value) {
                Cookie.save(key, value);
                
                if( user.cookies ) {
                    if( user.cookies[key] !== undefined ) {
                        // The cookie has already been created.
                        user.cookies[key].value = JSON.stringify(value);
                    } else {
                        // We need to fake the cookie until the next time the user's cookie set is requested
                        var c = {
                            'value': JSON.stringify(value)
                        };

                        user.cookies[key] = c;
                    }
                }
            },

            /*
             * deleteCookie:
             *      Remove a single cookie, if it exists
             *
             *  @param {string} key - the name of the cookie to delete.
             */
            deleteCookie: function(key) {
                var c;

                if( user.cookies && user.cookies[key] ) {
                    // Send the ID
                    c = Cookie.delete(user.cookies[key].id);
                    c.$promise.then(function(result){
                        if( result.status ) {
                            delete user.cookies[key];
                        }
                    });
                } else {
                    // Nothing to delete, so it worked :)
                    c = {
                        status: true
                    };
                }

                return c;
            },

            /*
             * clearCookies:
             *      Remove all a user's cookies.
             *
             *  @return {obj} the promise so you can take action on errors.
             */
            clearCookies: function() {
                var c = Cookie.deleteAll();
                c.$promise.then(function(result){
                    if( result.status ) {
                        user.cookies = {};
                    }
                });

                return c;
            },
            
            /*
             * getNav:
             *      Get the nav for the current user.
             *
             *  @param {string} pageId - OPTIONAL - id of the current page you want to edit... only applicable to admins, ignored for other users
             *  @param {string} accessKey - OPTIONAL - if logging in as a volunteer, this is the volunteer accesskey
             */
            getNav: function (pageId, accessKey) {
                return User.getNav({
                    page_id:    pageId,
                    accesskey:  accessKey
                });
            },
            
            /*
             * getSearchableArticles:
             *      Get the searchable articles.
             *
             *  @param {string} pageId - OPTIONAL - id of the current page you want to edit... for admins only
             */
            getSearchableArticles: function () {
                return User.getSearchableArticles();
            },
            /**
             *  getCustomFieldLabelsForVols
             *  We need to map custom fields labels to custom fields values
             *
             *  @customFieldsWithLabel : array CustomField Labels
             *  @customFieldsWithValues: Array CustomField Values
             *
             *  return returnArray: Array of Customfield values with labels
             */
            getCustomFieldLabelsForVols: function(customFieldsWithLabel,customFieldsWithValues) {

                var returnArray = [];
                angular.forEach(customFieldsWithLabel, function(invCustom){
                    angular.forEach(customFieldsWithValues, function(volCustom, key) {
                        if (volCustom.activity_extra_field_id == invCustom.id){
                            volCustom.title = invCustom.title
                            returnArray.push(volCustom);
                        }
                    });
                });
                return returnArray;
            }

        };
    }];
});

